import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';
import type { FooterNavProps } from '~/legacy/types';

const FooterNav = ({ menu }: FooterNavProps) => {
  const fireFooterLink = useNavigationLinkInteraction('footer');

  return (
    <div
      className="global-footer__links flex--center flex--wrap"
      role="navigation"
    >
      {menu.map(({ link, name, external }, index) => {
        const onClick = () => fireFooterLink(link, index + 1, { label: name });

        if (external) {
          return (
            <a
              href={link}
              className="btn btn--footer-overlay"
              key={name}
              onClick={onClick}
              rel="noopener noreferrer"
              target="_blank"
            >
              {name}
            </a>
          );
        }

        return (
          <a
            href={link}
            className="btn btn--footer-overlay"
            key={name}
            onClick={onClick}
          >
            {name}
          </a>
        );
      })}
    </div>
  );
};

export default FooterNav;
